/**
 * Utility functions for handling URLs across different environments
 */

/**
 * Get the base URL for the application
 * Uses Lovable production URL when deployed, localhost in development
 */
export const getBaseUrl = (): string => {
  // Si on est en mode production (pas de localhost), utiliser l'URL Lovable
  if (window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1') {
    // Déjà en production sur Lovable ou domaine custom
    return window.location.origin;
  }
  
  // En développement, utiliser localhost
  return window.location.origin;
};

/**
 * Get the public URL for sharing (always uses production URL when available)
 */
export const getPublicUrl = (): string => {
  // Si on est sur localhost ou un domaine Lovable, utiliser get-clan.com pour le partage
  if (window.location.hostname === 'localhost' || 
      window.location.hostname === '127.0.0.1' ||
      window.location.hostname.includes('lovable.app') ||
      window.location.hostname.includes('lovableproject.com')) {
    return 'https://get-clan.com';
  }
  
  // Sinon utiliser l'URL actuelle (déjà en production)
  return window.location.origin;
};

/**
 * Generate a public event URL
 */
export const generatePublicEventUrl = (slug: string): string => {
  return `${getPublicUrl()}/public-event/${slug}`;
};

/**
 * Get the Supabase URL for edge functions
 */
export const getSupabaseUrl = (): string => {
  return 'https://wqagrmomwzikqpxwiskl.supabase.co';
};

/**
 * Generate invitation URL (uses the invite function that redirects properly)
 */
export const generateInvitationUrl = (token: string): string => {
  return `${getPublicUrl()}/invite/${token}`;
};